(ns manage.feed-table.db
  (:require [clojure.edn :as edn]
            [clojure.string :as str]
            [common.url-template :as url-tpl]
            [re-frame.core :as rf]))

(rf/reg-event-fx :table.feed/init-table-with-type
  (fn [{:keys [db]} [_ type]]
    {:db (assoc-in db [:table.feed/meta :type] type)}))

(rf/reg-sub :table.feed/feed-type
  (fn [db]
    (get-in db [:table.feed/meta :type])))

(defn parse-import-errors
  "Best effort attempt to parse various known formats of import errors
  found in prod db."
  [last-run-details]
  (->> last-run-details
       (mapcat (fn [{:keys [reason problems]}]
                 (let [messages (mapv :message problems)]
                   (cond
                     (= reason "timeouted")
                     [{:title "Internal error"
                       :details "Import timeout"}]

                     ;; There's a weirdly string-serialized map that
                     ;; contains also human-readable errors that we try
                     ;; to extract.
                     (some (fn [message]
                             (and (string? message)
                                  (str/starts-with? message "throw+: "))) messages)
                     (->> messages
                          (mapv (fn [x]
                                  (let [m (try
                                            (-> x
                                                (str/replace "\n" "")
                                                (str/replace-first "throw+: " "")
                                                ;; Remove :pred key because it contains a fn
                                                ;; that can't be read by edn reader.
                                                (str/replace #":pred.*?:val" ":val")
                                                edn/read-string)
                                            (catch js/Error _e
                                              {:message "Unknown error" :details {:problems [{:message x}]}}))]
                                    {:title (:message m)
                                     :details (let [details (or (->> m :details :problems (map :message) (str/join "\n") not-empty)
                                                                (->> m :field-problems (map :message) (str/join "\n")))]
                                                (if (empty? details)
                                                  "-"
                                                  details))}))))

                     :else
                     [{:title (or reason "Internal error")
                       :details (str/join "\n" messages)}]))))
       vec))

(rf/reg-event-fx :table.feed/show-import-problems
  (fn [_ [_ last-run-details]]
    {:fx [[:dispatch [:modal/open {:id :table.feed/import-problems
                                   :props {:details (parse-import-errors last-run-details)}}]]]}))

(rf/reg-event-fx :table.feed/get-latest-import-file
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [_ url-context] :as cofx} [_ feed-id]]
    (let [uri (url-tpl/render :api/feed-importers-latest-import-file
                              (assoc url-context
                                     :feed-importer-id feed-id))]
      {:http {:method :get
              :uri uri
              :headers {"Authorization" (:resource.user/token cofx)}
              :response-format :binary+filename
              :on-success [::latest-import-file-success feed-id]
              :on-failure [::latest-import-file-failure feed-id]}})))

(rf/reg-event-fx
  ::latest-import-file-success
  (fn [{:keys [db]} [event feed-id response]]
    {:db (assoc-in db [:feeds-data feed-id] response)
     :fx [[:binary/download response]
          [:dispatch [:toaster-bus/add {:id :content-page/download-errors-success
                                        :type :success
                                        :message "The import errors was fetched successfully"
                                        :event event}]]]}))

(rf/reg-event-fx
  ::latest-import-file-failure
  (fn [_ [event reject response]]
    {:fx [[:dispatch [:toaster-bus/add {:id :content-page/download-errors-failure
                                        :type :error
                                        :message "Something went wrong while fetching import errors."
                                        :event event
                                        :response response}]]
          [:promise/reject reject]]}))
